import { Card, CardActions, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Link, useNavigate } from "react-router-dom";
import PrivatePredictionSumTable from './PrivatePredictionSumTable';
import PrivateTestPredictionTable from './PrivateTestPredictionTable';

export default function Prediction() {
    const token = sessionStorage.getItem('token');

    let navigate = useNavigate();

    const loginPageRedirect = () => {
        navigate("/login");
    }

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={6} >
                    <div style={{ textAlign: "justify" }}>
                        <h3> Summary of Predictions</h3>
                        <p>Instructions:</p>
                        <ul>
                            <li>Diagram tutorial is in here.</li>
                            <li>A tutorial video is <a href='https://g2pdeep.org/workshop'>here</a>.</li>
                        </ul>
                    </div>
                </Grid>
                {token != null ?
                    <Grid item xs={6} >
                        <Link to='/create_prediction'>
                            {/* <Button style={{
                                marginTop: '10%',
                                marginBottom: "10%",
                                marginRight: '10%',
                                backgroundColor: '#2A3F54',
                                color: 'white',
                                float: 'right'
                            }} >Create model Prediction</Button> */}
                             <button type='button' style={{
                                margin: '10%',
                                padding: '5px',
                                backgroundColor: '#2A3F54',
                                color: 'white',
                                float: 'right',
                                borderRadius: '5px'
                            }}>CREATE MODEL PREDICTION</button>
                        </Link>

                    </Grid>
                    : ''}
            </Grid>
            <br></br>
            <br></br>
            <div>
                {token != null ? (
                    <PrivateTestPredictionTable token={token} />
                ) : (
                    <Card style={{border:'1px solid'}}>
                        <CardHeader title={<Typography variant={"h6"} style={{
                            float: 'left'
                        }}>Predictions Summary</Typography>} />
                        <Divider></Divider>
                        <CardContent> Please login to see your prediction information</CardContent>
                        <CardActions>
                            {/* <Link to="/login"> */}
                            <Button style={{
                                margin: 'auto',
                                backgroundColor: '#2A3F54',
                                color: 'white'
                            }} onClick={loginPageRedirect} >Login</Button>
                            {/* </Link> */}
                        </CardActions>
                    </Card>)}
            </div>

        </>
    )
}
